import QRCode from "qrcode";

// A2 portrait, in mm. The QR fills the page width less a 10 mm print-safe border, centred on the
// page, with the same "Powered by" footer the invoice prints carry.
const PAGE_W = 420;
const PAGE_H = 594;
const BORDER = 10;
const QR_SIZE = PAGE_W - 2 * BORDER;

/** Same normalization the backends use when they look a scanned vehicle up. */
export const normalizeVehicleNumber = (v) => (v || "").toUpperCase().replace(/\s+/g, "");

/**
 * Vector QR (SVG markup) for the vehicle number. High error correction survives glare, dirt
 * and a slight angle on the windshield; the 4-module quiet zone the scanner needs is included.
 */
export function buildQrSvg(vehicleNumber) {
  return QRCode.toString(vehicleNumber, { type: "svg", errorCorrectionLevel: "H", margin: 4 });
}

function escapeHtml(s) {
  return s.replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
}

function pageHtml(vehicleNumber, svg) {
  const label = escapeHtml(vehicleNumber);
  return `<!doctype html><html><head><meta charset="utf-8"><title>QR ${label}</title><style>
@page { size: ${PAGE_W}mm ${PAGE_H}mm; margin: 0; }
* { -webkit-print-color-adjust: exact; print-color-adjust: exact; box-sizing: border-box; }
html, body { margin: 0; padding: 0; background: #fff; }
.page { width: ${PAGE_W}mm; height: ${PAGE_H}mm; padding: ${BORDER}mm; display: flex;
  flex-direction: column; align-items: center; overflow: hidden; }
.qr { width: ${QR_SIZE}mm; height: ${QR_SIZE}mm; flex-shrink: 0; margin: auto 0; }
.qr svg { width: 100%; height: 100%; display: block; shape-rendering: crispEdges; }
.footer { font: 400 9mm/1 Arial, Helvetica, sans-serif; color: #555; }
</style></head><body><div class="page">
<div class="qr">${svg}</div>
<div class="footer">Powered by Revcon Technologies &bull; revcontech.com</div>
</div></body></html>`;
}

/**
 * Opens the browser print dialog with the sticker on one A2 page (choose A2 paper, 100% scale,
 * or "Save as PDF"). Printing happens in a hidden frame so the app page itself is untouched.
 */
export async function printQrSticker(vehicleNumber) {
  const number = normalizeVehicleNumber(vehicleNumber);
  const svg = await buildQrSvg(number);

  const frame = document.createElement("iframe");
  frame.setAttribute("aria-hidden", "true");
  Object.assign(frame.style, { position: "fixed", right: "0", bottom: "0", width: "0", height: "0", border: "0" });
  document.body.appendChild(frame);

  const win = frame.contentWindow;
  win.document.open();
  win.document.write(pageHtml(number, svg));
  win.document.close();

  const cleanup = () => setTimeout(() => frame.remove(), 500);
  win.addEventListener("afterprint", cleanup);
  // Give the frame a moment to lay out before printing
  setTimeout(() => {
    win.focus();
    win.print();
  }, 300);
  setTimeout(() => frame.isConnected && frame.remove(), 5 * 60 * 1000);
}
